// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../imgs/babLetras/b.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../imgs/babLetras/a.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../imgs/babLetras/I.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../imgs/babLetras/T.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../imgs/babLetras/bMobile.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../imgs/babLetras/aMobile.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../imgs/babLetras/IMobile.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../imgs/babLetras/TMobile.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.svgLoad{
	width: 100px;
	height: 220px;
	filter: drop-shadow(0px 0px 5px var(--white-color)) drop-shadow(0px 0px 15px var(--white-color));
	animation: secondAnimation 3s linear 3s infinite;
}

.logoSVGB{
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
	background-repeat: no-repeat;
}

.svgLoad:nth-child(3){
	margin-left: -35px;
}

.logoSVGA{
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
	background-repeat: no-repeat;
    width: 149px;
    margin-left: 10px;
}
.logoSVGI{
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
	background-repeat: no-repeat;
    width: 13px;
    margin-left: 12px;
}
.logoSVGT{
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
	background-repeat: no-repeat;  
    margin-left: 12px;
}


.textLoad{
	color: var(--white-color);
	font-size: 2em;
	font-family: 'Cardo';
}

.textLoad::after {
	animation: changeLetter 3s linear 3s infinite;
	content: "";
  }


@media(max-width: 767px){
	.svgLoad{
		width: 53px;
		height: 80px;
	}
	.logoSVGB{
		background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
		background-repeat: no-repeat;
	}
	.svgLoad:nth-child(3){
		margin-left: -20px;
		margin-right: 5px;
	}

	.logoSVGA{
		background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
		background-repeat: no-repeat;
		width: 76px;
		height: 95px;
		margin-left: 1%;
	}
	.logoSVGI{
		background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
		background-repeat: no-repeat;
		width: 13px;
		margin-left: 0.8%;
	}
	.logoSVGT{
		background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
		background-repeat: no-repeat;
		margin-left: 0.8%;
	}
	.textLoad{
		font-size: 1em;
	}
}




@keyframes changeLetter {
	0% {
	  content: ".";
	}
	50% {
	  content: "..";
	}
	100% {
		content: "...";
	  }
}
  

@keyframes secondAnimation {
			0%{
				filter: drop-shadow(0px 0px 5px var(--white-color)FF) drop-shadow(0px 0px 15px var(--white-color)FF);
			}
			25%{
				filter: drop-shadow(0px 0px 5px var(--white-color)77) drop-shadow(0px 0px 15px var(--white-color)77);
			}
			50%{
				filter: drop-shadow(0px 0px 5px var(--white-color)00) drop-shadow(0px 0px 15px var(--white-color)00);
			}
			75%{
				filter: drop-shadow(0px 0px 5px var(--white-color)77) drop-shadow(0px 0px 15px var(--white-color)77);
			}
			100%{
				filter: drop-shadow(0px 0px 5px var(--white-color)FF) drop-shadow(0px 0px 15px var(--white-color)FF);
			}
		
	}`, "",{"version":3,"sources":["webpack://./src/assets/css/auxiliar/loading.css"],"names":[],"mappings":";AACA;CACC,YAAY;CACZ,aAAa;CAEb,gGAAgG;CAChG,gDAAgD;AACjD;;AAEA;CACC,yDAAmD;CACnD,4BAA4B;AAC7B;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,yDAAmD;CACnD,4BAA4B;IACzB,YAAY;IACZ,iBAAiB;AACrB;AACA;CACC,yDAAmD;CACnD,4BAA4B;IACzB,WAAW;IACX,iBAAiB;AACrB;AACA;CACC,yDAAmD;CACnD,4BAA4B;IACzB,iBAAiB;AACrB;;;AAGA;CACC,yBAAyB;CACzB,cAAc;CACd,oBAAoB;AACrB;;AAEA;CACC,6CAA6C;CAC7C,WAAW;EACV;;;AAGF;CACC;EACC,WAAW;EACX,YAAY;CACb;CACA;EACC,yDAAyD;EACzD,4BAA4B;CAC7B;CACA;EACC,kBAAkB;EAClB,iBAAiB;CAClB;;CAEA;EACC,yDAAyD;EACzD,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,eAAe;CAChB;CACA;EACC,yDAAyD;EACzD,4BAA4B;EAC5B,WAAW;EACX,iBAAiB;CAClB;CACA;EACC,yDAAyD;EACzD,4BAA4B;EAC5B,iBAAiB;CAClB;CACA;EACC,cAAc;CACf;AACD;;;;;AAKA;CACC;GACE,YAAY;CACd;CACA;GACE,aAAa;CACf;CACA;EACC,cAAc;GACb;AACH;;;AAGA;GACG;IAEC,oGAAoG;GACrG;GACA;IAEC,oGAAoG;GACrG;GACA;IAEC,oGAAoG;GACrG;GACA;IAEC,oGAAoG;GACrG;GACA;IAEC,oGAAoG;GACrG;;CAEF","sourcesContent":["\r\n.svgLoad{\r\n\twidth: 100px;\r\n\theight: 220px;\r\n\t-webkit-filter: drop-shadow(0px 0px 5px var(--white-color)) drop-shadow(0px 0px 15px var(--white-color));\r\n\tfilter: drop-shadow(0px 0px 5px var(--white-color)) drop-shadow(0px 0px 15px var(--white-color));\r\n\tanimation: secondAnimation 3s linear 3s infinite;\r\n}\r\n\r\n.logoSVGB{\r\n\tbackground-image: url('../../imgs/babLetras/b.svg');\r\n\tbackground-repeat: no-repeat;\r\n}\r\n\r\n.svgLoad:nth-child(3){\r\n\tmargin-left: -35px;\r\n}\r\n\r\n.logoSVGA{\r\n\tbackground-image: url('../../imgs/babLetras/a.svg');\r\n\tbackground-repeat: no-repeat;\r\n    width: 149px;\r\n    margin-left: 10px;\r\n}\r\n.logoSVGI{\r\n\tbackground-image: url('../../imgs/babLetras/I.svg');\r\n\tbackground-repeat: no-repeat;\r\n    width: 13px;\r\n    margin-left: 12px;\r\n}\r\n.logoSVGT{\r\n\tbackground-image: url('../../imgs/babLetras/T.svg');\r\n\tbackground-repeat: no-repeat;  \r\n    margin-left: 12px;\r\n}\r\n\r\n\r\n.textLoad{\r\n\tcolor: var(--white-color);\r\n\tfont-size: 2em;\r\n\tfont-family: 'Cardo';\r\n}\r\n\r\n.textLoad::after {\r\n\tanimation: changeLetter 3s linear 3s infinite;\r\n\tcontent: \"\";\r\n  }\r\n\r\n\r\n@media(max-width: 767px){\r\n\t.svgLoad{\r\n\t\twidth: 53px;\r\n\t\theight: 80px;\r\n\t}\r\n\t.logoSVGB{\r\n\t\tbackground-image: url('../../imgs/babLetras/bMobile.svg');\r\n\t\tbackground-repeat: no-repeat;\r\n\t}\r\n\t.svgLoad:nth-child(3){\r\n\t\tmargin-left: -20px;\r\n\t\tmargin-right: 5px;\r\n\t}\r\n\r\n\t.logoSVGA{\r\n\t\tbackground-image: url('../../imgs/babLetras/aMobile.svg');\r\n\t\tbackground-repeat: no-repeat;\r\n\t\twidth: 76px;\r\n\t\theight: 95px;\r\n\t\tmargin-left: 1%;\r\n\t}\r\n\t.logoSVGI{\r\n\t\tbackground-image: url('../../imgs/babLetras/IMobile.svg');\r\n\t\tbackground-repeat: no-repeat;\r\n\t\twidth: 13px;\r\n\t\tmargin-left: 0.8%;\r\n\t}\r\n\t.logoSVGT{\r\n\t\tbackground-image: url('../../imgs/babLetras/TMobile.svg');\r\n\t\tbackground-repeat: no-repeat;\r\n\t\tmargin-left: 0.8%;\r\n\t}\r\n\t.textLoad{\r\n\t\tfont-size: 1em;\r\n\t}\r\n}\r\n\r\n\r\n\r\n\r\n@keyframes changeLetter {\r\n\t0% {\r\n\t  content: \".\";\r\n\t}\r\n\t50% {\r\n\t  content: \"..\";\r\n\t}\r\n\t100% {\r\n\t\tcontent: \"...\";\r\n\t  }\r\n}\r\n  \r\n\r\n@keyframes secondAnimation {\r\n\t\t\t0%{\r\n\t\t\t\t-webkit-filter: drop-shadow(0px 0px 5px var(--white-color)FF) drop-shadow(0px 0px 15px var(--white-color)FF);\r\n\t\t\t\tfilter: drop-shadow(0px 0px 5px var(--white-color)FF) drop-shadow(0px 0px 15px var(--white-color)FF);\r\n\t\t\t}\r\n\t\t\t25%{\r\n\t\t\t\t-webkit-filter: drop-shadow(0px 0px 5px var(--white-color)77) drop-shadow(0px 0px 15px var(--white-color)77);\r\n\t\t\t\tfilter: drop-shadow(0px 0px 5px var(--white-color)77) drop-shadow(0px 0px 15px var(--white-color)77);\r\n\t\t\t}\r\n\t\t\t50%{\r\n\t\t\t\t-webkit-filter: drop-shadow(0px 0px 5px var(--white-color)00) drop-shadow(0px 0px 15px var(--white-color)00);\r\n\t\t\t\tfilter: drop-shadow(0px 0px 5px var(--white-color)00) drop-shadow(0px 0px 15px var(--white-color)00);\r\n\t\t\t}\r\n\t\t\t75%{\r\n\t\t\t\t-webkit-filter: drop-shadow(0px 0px 5px var(--white-color)77) drop-shadow(0px 0px 15px var(--white-color)77);\r\n\t\t\t\tfilter: drop-shadow(0px 0px 5px var(--white-color)77) drop-shadow(0px 0px 15px var(--white-color)77);\r\n\t\t\t}\r\n\t\t\t100%{\r\n\t\t\t\t-webkit-filter: drop-shadow(0px 0px 5px var(--white-color)FF) drop-shadow(0px 0px 15px var(--white-color)FF);\r\n\t\t\t\tfilter: drop-shadow(0px 0px 5px var(--white-color)FF) drop-shadow(0px 0px 15px var(--white-color)FF);\r\n\t\t\t}\r\n\t\t\r\n\t}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
